import type { TrustData } from "~/types/trust-account";
import type { TrustAccount } from "@prisma/client"

export const useTrustAccount = () => {
    const createTrust = async (
        trustData: TrustData
    ) => {
        try {
            const response = await $fetch('/api/v1/trust-account', {
                method: 'POST',
                body: trustData,
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error creating trust account:', error);
            return { data: null, error };
        }
    };

    const getAllTrustAccounts = async () => {
        try {
            const accounts = await $fetch('/api/v1/trust-account', {
                method: 'GET',
            });

            return { data: accounts, error: null };
        } catch (error) {
            console.error('Error fetching trust accounts:', error);
            return { data: null, error };
        }
    };

    const getTrustAccountById = async (
        accountId: string, 
        filterArchivedLedgers: boolean,
        options?: {
            selectedLedgerId?: string;
            startedAt?: Date;
            endedAt?: Date;
        }
    ) => {
        const params = new URLSearchParams();
        params.append('filterArchivedLedgers', filterArchivedLedgers.toString());

        if (options?.selectedLedgerId) {
            params.append('selectedLedgerId', options.selectedLedgerId.toString());
        }
        if (options?.startedAt) {
            params.append('startedAt', options.startedAt.toISOString());
        }
        if (options?.endedAt) {
            params.append('endedAt', options.endedAt.toISOString());
        }

        try {
            const account = await $fetch(`/api/v1/trust-account/${accountId}?${params.toString()}`, {
                method: 'GET',
            });

            return { data: account, error: null };
        } catch (error) {
            console.error('Error fetching trust account:', error);
            return { data: null, error };
        }
    };

    const updateTrustAccountById = async (
        updatedTrustAccount: TrustAccount & { 
            bsb?: string, 
            accountNumber?: string 
        }
    ) => {
        try {
            const response = await $fetch(`/api/v1/trust-account/${updatedTrustAccount.id}`, {
                method: 'PUT',
                body: updatedTrustAccount,
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error updating trust account:', error);
            return { data: null, error };
        }
    };

    return {
        createTrust,
        getAllTrustAccounts,
        getTrustAccountById,
        updateTrustAccountById
    };
};
